import { Dispatch, SetStateAction } from 'react'
import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { validateBic } from 'services/BankValidationService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { MappedErrorMessageState } from 'types/errors'
import { QueryMetaType } from 'types/reactQuery'

export const useBicValidation = (
  bic: string,
  setRequestError: Dispatch<SetStateAction<MappedErrorMessageState>>,
  enabled = false
) => {
  const meta: QueryMetaType = {
    excludedErrorCodes: [400],
    onErrorAdditional: (error: BaseErrorResponse) => {
      setRequestError({
        errorCode: error.status,
        show: true,
      })
    },
    errorAdditionalData: { bic },
  }

  return useQuery({
    queryKey: reactQueryKeys.validateBic(bic),
    queryFn: () => validateBic(bic),
    enabled: enabled,
    gcTime: 0,
    meta,
  })
}
